import {
  catalogueSummary,
  useImportCsvMutation,
} from '@/features/imports/api/use-import-csv-mutation';
import { queryKeys } from '@/lib/query-keys';
import type {
  ImportMembershipPlansCsvInput,
  ImportMembershipPlansCsvResponse,
} from '@borradh-workspace/api-client/types';
import { importMembershipPlansCsvResponseSchema } from '@borradh-workspace/contracts';

export const useImportMembershipPlansCsv = (options?: {
  onSuccess?: (result: ImportMembershipPlansCsvResponse) => void;
}) => {
  const { mutate, mutateAsync, isImporting } = useImportCsvMutation<
    ImportMembershipPlansCsvInput,
    ImportMembershipPlansCsvResponse
  >({
    path: 'membership-plans/import-csv',
    schema: importMembershipPlansCsvResponseSchema,
    event: 'membership_plans_imported_csv',
    track: (r) => ({
      imported: r.imported,
      updated: r.updated,
      skipped: r.skipped,
      rowsInFile: r.rowsInFile,
      servicesLinked: r.servicesLinked,
    }),
    invalidate: () => [queryKeys.membershipPlans.all()],
    summarize: catalogueSummary,
    onSuccess: options?.onSuccess,
  });
  return {
    importMembershipPlansCsv: mutate,
    importMembershipPlansCsvAsync: mutateAsync,
    isImporting,
  };
};
